const headerVideo = () => {

    let header_video_element = document.querySelector(".video-pozadina video");
    header_video_element.autoplay = true;
    header_video_element.muted = true;

    if (matchMedia) {
        let mobile_screen = window.matchMedia("(min-width: 48em)");
        disableVideoMobile(mobile_screen, header_video_element);
        window.addEventListener("resize", function () {
            disableVideoMobile(mobile_screen, header_video_element);
        });
    }

};



const disableVideoMobile = (mobile_screen, video_element) => {

    if (mobile_screen.matches) {
        if (video_element.style.display == "none") {

            video_element.style.display = "block";
            video_element.src = "assets/movie/pozadina.mp4";

        }


    } else {
        video_element.style.display = "none";
        video_element.src = "";

    }

};

export {
    headerVideo
};